import type { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import type LoggerService from '@app/service/logger.service';
import { angularjs } from '@app/service/migration-helpers/angularjs.injection';
import { HTTP_ERROR_STATUSES_SKIP_LOGGING } from './http-error.constants';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  private loggerService: LoggerService = inject(angularjs.loggerService);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (!HTTP_ERROR_STATUSES_SKIP_LOGGING.includes(error.status)) {
          this.loggerService.error('HTTP Error', {
            status: error.status,
            url: req.url,
            method: req.method,
            data: error.error
          });
        }
        return throwError(() => error);
      })
    );
  }
}
